import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidReadingMatrixCategorise } from '../../../../mechanics/rid-reading-matrix-categorise/rid-reading-matrix-categorise';

@Component({
  selector: 'app-reading-matrix-categorise-page',
  imports: [RidReadingMatrixCategorise],
  templateUrl: './reading-matrix-categorise-page.html',
})
export class ReadingMatrixCategorisePage {
  protected readonly $router = inject(Router);
}
